var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.9665C15.8475 18.9665 18.9665 15.8475 18.9665 11.9999C18.9665 8.15229 15.8475 5.0332 11.9999 5.0332C8.15229 5.0332 5.0332 8.15229 5.0332 11.9999C5.0332 15.8475 8.15229 18.9665 11.9999 18.9665Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 20.0669C7.54516 20.0669 3.93359 16.4554 3.93359 12.0003C3.93359 7.54516 7.54516 3.93359 12.0003 3.93359C16.4554 3.93359 20.0669 7.54516 20.0669 12.0003C20.0669 16.4554 16.4554 20.0669 12.0003 20.0669Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27246 9.98916C9.32634 8.63025 10.2542 7.60059 11.9903 7.60059C13.5707 7.60059 14.6363 8.54045 14.6363 9.82154C14.6363 10.7494 14.1693 11.4019 13.3791 11.8749C12.6069 12.3298 12.3854 12.6471 12.3854 13.2637V13.6289H11.1462L11.1402 13.15C11.1103 12.3059 11.4755 11.7671 12.2956 11.2762C13.0199 10.8392 13.2774 10.492 13.2774 9.87542C13.2774 9.19895 12.7446 8.70208 11.9244 8.70208C11.0983 8.70208 10.5655 9.19895 10.5116 9.98916H9.27246Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7745 16.4009C11.3374 16.4009 10.9902 16.0657 10.9902 15.6287C10.9902 15.1917 11.3374 14.8564 11.7745 14.8564C12.2234 14.8564 12.5647 15.1917 12.5647 15.6287C12.5647 16.0657 12.2234 16.4009 11.7745 16.4009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.58e8ab50bfb462a5df3f459cdc210411.svg";
export { ForwardRef as ReactComponent };